import React from 'react';
import FAQ from '../../components/faq/faq'; 

const FAQPage = () => {
    return (
        <main>
            <FAQ />
        </main>
    );
};

export default FAQPage;
